import { useAppSelector } from '../slices/index';
import { getUkDate } from '../utilities';

const ReportGarnet = () => {
	const cases = useAppSelector(state => state.cases);

	return (
		<table style={{ borderSpacing: 0, borderCollapse: 'collapse' }}>
			<thead>
				{(cases.report.rows || []).length > 0 &&
					<tr>
						<th>Property/Client Name/PLS Reference</th>
						<th>Casetype</th>
						<th>Casekey</th>
						<th>Fee Earner</th>
						<th>Introducer</th>
						<th>Case Status Description</th>
						<th>Client 01 Full Name</th>
						<th>Client 02 Full Name</th>
						<th>Transaction Property Address</th>
						<th>Transaction Property Postcode</th>
						<th>Tenure</th>
						<th>Start Month</th>
						<th>File Opened</th>
						<th>Searches Checklist Ordered Date</th>
						<th>Searches Ordered? Y/N</th>
						<th>Class Of Title</th>
						<th>Lease Term</th>
						<th>Restrictions</th>
						<th>Price At Registration</th>
						<th>Existing Lender 01</th>
						<th>Existing Lender 01 Charge Date</th>
						<th>Existing Lender 02</th>
						<th>Existing Lender 02 Charge Date</th>
						<th>Office Copies Received Freehold</th>
						<th>Office Copies Received Leasehold</th>
						<th>OELastEdition</th>
						<th>OS1 Received</th>
						<th>OS1 Expiry</th>
						<th>OS2 Received</th>
						<th>OS2 Expiry</th>
						<th>Client 01 K16 Complete</th>
						<th>Client 02 K16 Complete</th>
						<th>Contract Pack Received Date</th>
						<th>Draft Contracts Arrived? Y/N</th>
						<th>Title Review Complete Date</th>
						<th>Enquiries Raised Date</th>
						<th>Enquiries Sent? Y/N</th>
						<th>Enquiries Response Date</th>
						<th>Replies to Enquiries</th>
						<th>Enquiries Complete Date</th>
						<th>Searches Checklist Received Date</th>
						<th>All Searches Received? Y/N</th>
						<th>Report On Title Sent</th>
						<th>Report on Title Sent? Y/N</th>
						<th>Deposit Requested From Client</th>
						<th>Exchange Date</th>
						<th>Exchanged</th>
						<th>Completion Date</th>
						<th>File Cancelled</th>
						<th>File Closed Date</th>
					</tr>
				}
			</thead>
			{(cases.report.rows || []).map((r: any) => {
				return (
					<tbody>
						<tr>
							<td>{r.TransactionPropertyAddress + ' / ' + r.Client01FullName + ' / ' + r.casekey}</td>
							<td>{r.casetype}</td>
							<td>{r.casekey}</td>
							<td>{r.FeeEarner}</td>
							<td>{r.Introducer}</td>
							<td>{r.CaseStatusDescription}</td>
							<td>{r.Client01FullName}</td>
							<td>{r.Client02FullName}</td>
							<td>{r.TransactionPropertyAddress}</td>
							<td>{r.TransactionPropertyPostcode}</td>
							<td>{r.Tenure}</td>
							<td>{r.StartMonth}</td>
							<td>{getUkDate(r.FileOpened)}</td>
							<td>{getUkDate(r.SearchesChecklistOrderedDate)}</td>
							<td>{r.SearchesOrderedQ}</td>
							<td>{r.ClassOfTitle}</td>
							<td>{r.LeaseTerm}</td>
							<td>{r.Restrictions}</td>
							<td>{r.PriceAtRegistration}</td>
							<td>{r.ExistingLender01}</td>
							<td>{getUkDate(r.ExistingLender01ChargeDate)}</td>
							<td>{r.ExistingLender02}</td>
							<td>{getUkDate(r.ExistingLender02ChargeDate)}</td>
							<td>{getUkDate(r.OfficeCopiesReceivedFreehold)}</td>
							<td>{getUkDate(r.OfficeCopiesReceivedLeasehold)}</td>
							<td>{getUkDate(r.OELastEdition)}</td>
							<td>{getUkDate(r.OS1Received)}</td>
							<td>{getUkDate(r.OS1Expiry)}</td>
							<td>{getUkDate(r.OS2Received)}</td>
							<td>{getUkDate(r.OS2Expiry)}</td>
							<td>{r.Client01K16Complete}</td>
							<td>{r.Client02K16Complete}</td>
							<td>{getUkDate(r.ContractPackReceivedDate)}</td>
							<td>{r.DraftContractsArrivedQ}</td>
							<td>{getUkDate(r.TitleReviewCompleteDate)}</td>
							<td>{getUkDate(r.EnquiriesRaisedDate)}</td>
							<td>{r.EnquiriesSentQ}</td>
							<td>{getUkDate(r.EnquiriesResponseDate)}</td>
							<td>{r.RepliestoEnquiries}</td>
							<td>{getUkDate(r.EnquiriesCompleteDate)}</td>
							<td>{getUkDate(r.SearchesChecklistReceivedDate)}</td>
							<td>{r.AllSearchesReceivedQ}</td>
							<td>{getUkDate(r.ReportOnTitleSent)}</td>
							<td>{r.ReportonTitleSentQ}</td>
							<td>{r.DepositRequestedFromClient}</td>
							<td>{getUkDate(r.ExchangeDate)}</td>
							<td>{r.Exchanged}</td>
							<td>{getUkDate(r.CompletionDate)}</td>
							<td>{getUkDate(r.FileCancelled)}</td>
							<td>{getUkDate(r.FileClosedDate)}</td>
						</tr>
					</tbody>
				)
			})}
		</table>
	);
}

export default ReportGarnet;